
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.212 9.78a5.76 5.76 0 00.459-2.28c0-.595-.093-1.165-.255-1.693-.553.124-1.13.19-1.734.19-2.601 0-4.905-1.248-6.307-3.172a7.712 7.712 0 01-4.02 4.03c-.034.207-.034.43-.034.645 0 3.32 2.762 6.005 6.179 6.005.893 0 1.751-.19 2.524-.529.485.9.706 1.347.689 1.347C10.319 14.777 9.24 15 8.5 15c-2.057 0-4.02-.785-5.466-2.197a7.425 7.425 0 01-1.903-3.048H0V5.997h.926C1.641 2.577 4.76 0 8.5 0a7.83 7.83 0 015.457 2.197 7.365 7.365 0 012.1 3.8H17v3.758h-.051l-3.026 2.7-4.505-.495v-1.38h4.106l.688-.8zM6.18 7.31c.255 0 .501.1.68.28a.925.925 0 010 1.322.98.98 0 01-.68.273c-.536 0-.97-.413-.97-.933s.434-.942.97-.942zm4.632 0c.536 0 .96.421.96.942 0 .52-.425.933-.96.933-.535 0-.969-.413-.969-.933s.434-.942.969-.942z","fill":"#133651"}})])
          )
        }
      }
    